import { httpClient } from "@services/api/httpClient";

const verifyApplicantBelongsToRecruiterOffer = async (applicantEmail: string, offerId: number) => {
    const response = await httpClient.post(`/recruiter/verify-applicant-belongs-to-offer`, { applicantEmail, offerId });
    return response.data;
};

export default verifyApplicantBelongsToRecruiterOffer;